export enum RecordingStatus {
  Completed = "completed",
  InProgress = "in-progress",
  Absent = "absent"
}